import React, { useState } from 'react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
import { ReviewChecklist } from './ReviewChecklist';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  const current = samplePrompts[active];
  return <section aria-label="What is an AI prompt" className="bg-transparent" data-id="element-235" data-mp="37nwa3b38bcsn">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: '20px',
      paddingBottom: '24px'
    }} data-id="element-236" data-mp="37pz569j8nw48">
        <div className="text-center" data-id="element-237" data-mp="2ymy26hpo6l4s">
          <h2 className="font-display text-3xl font-black uppercase text-plum sm:text-4xl" data-id="element-238" data-mp="2ynzndf0ego08">What is an AI prompt?</h2>
          <p className="mx-auto mt-3 max-w-2xl text-base text-plum/70" data-id="element-239" data-mp="33mkpjjz7phrb">
            An AI prompt is an <span className="font-bold text-grape" data-id="element-240" data-mp="wwwb6lav31dk">instruction</span> you provide to an artificial intelligence tool to guide the response you receive.
          </p>
          <p className="mx-auto mt-2 max-w-2xl text-base text-plum/70" data-id="element-241" data-mp="30hflnfjgxuyt">
            Instead of asking a vague question, a structured prompt defines the role, context, task, relevant information, and desired output.
          </p>
        </div>

        <PromptFlow data-id="element-242" data-mp="3a78yejvckg4n" />
        <p className="mx-auto mt-4 max-w-xl text-center text-xs text-plum/55" data-id="element-243" data-mp="3a9v0w53ds5g0">
          The quality of the result depends on the information you provide, the AI tool you use, and your review of the output.
        </p>

        <PromptDemo data-id="element-244" data-mp="2dhhtrrtcdcl4" />

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-245" data-mp="2di9o6zb7d49t">
          <h3 className="text-center font-display text-xl font-black uppercase text-plum sm:text-2xl" data-id="element-246" data-mp="2djksd08k8e1g">Prompt samples</h3>
          <p className="mt-2 text-center text-sm text-plum/60" data-id="element-247" data-mp="2mi668i3374vw">
            Explore examples of how the system works. Each prompt uses customizable fields so you can adapt it to your situation.
          </p>

          <div role="tablist" aria-label="Sample prompts" className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-248" data-mp="1s7ad6zbgm9n">
            {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-grape/40 ${active === i ? 'bg-plum text-grape-soft' : 'border border-grape-soft/50 bg-white text-plum/70 hover:text-plum'}`} data-id="element-249" data-mp="9sdek5djozu5" data-mpi={i}>
                #{sp.n} · {sp.title}
              </button>)}
          </div>
          <p className="mt-3 text-center text-sm text-plum/65" data-id="element-250" data-mp="1iosr13bi3y">{current.summary}</p>

          <div className="mt-5" role="tabpanel" data-id="element-251" data-mp="4ubtjewk6qg1">
            <PromptCard key={current.n} prompt={current} data-id="element-252" data-mp="33jk5zqsg656s" />
          </div>

          <ReviewChecklist data-id="element-253" data-mp="33hfzr272su3c" />
        </div>
      </div>
    </section>;
}